var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactUs45X36 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 45 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 11.279v22.705c0 .956 1.349 2.09 2.31 2.012h40.264c.943.046 2.25-1.077 2.25-2.012V11.279L22.624 24.352z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M44.827 2.132a2.6 2.6 0 0 0-.682-1.449c-.397-.396-1.01-.64-1.569-.683L2.143.009C.989.141.099 1.026 0 2.189l.002 5.342.097.143L22.441 20.94 44.767 7.65l.064-.176c-.129-1.716.16-3.651-.004-5.342"
})));
export default SvgContactUs45X36;